module.exports = res => res.rows.map(row => row.doc).filter(x => x)
